/* eslint-disable */

import React from "react";
import { createBrowserRouter } from "react-router-dom";

// 引入组件
import Welcome from "../pages/Welcome";
import Login from "../pages/D5Login";
import OauthRedirect from "../pages/Redirect";
import OauthRedirectWechat from "../pages/RedirectWechat";
import Register from "../pages/D5Signup";
import Chat from "../pages/Chat";
import NotFond from "../pages/NotFound";
import DoctaAiTest from "../pages/DoctaAiTest";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import SignupPage from "../pages/D5Signup";
import VerifyPage from "../pages/D5Verify";
import DOCS from "../pages/Docs";
import Greeting from "../pages/components/Greeting";
import DoctaAiChat from "../pages/DoctaAiTest/DoctaAiChat";
import ChatPage from "../pages/components/ChatPage";
import UpgradePlans from "../pages/UpgradePlans";
import LoginByPhonePage from "../pages/D5LoginByPhone";
import ForgetPassword from "../pages/ForgetPassword";

// react 路由
const router = createBrowserRouter([
	{
		path: "/",
		element: <Login />,
	},
	{
		path:"/forget-password",
		element:<ForgetPassword />,
	},
	{
		path: "/login",
		element: <Login />,
	},
	{
		path: "/login-by-phone",
		element: <LoginByPhonePage />,
	},
	{
		path: "/signup",
		element: <SignupPage />,
	},
	{
		path: "/verify",
		element: <VerifyPage />,
	},
	{
		path: "/oauth2/redirect",
		element: <OauthRedirect />,
	},
	{
		path: "/oauth2/wechatredirect",
		element: <OauthRedirectWechat />,
	},
	{
		path: "plans",
		element: <UpgradePlans />,
	},
	{},

	{
		element: <DoctaAiTest />,
		children: [
			{
				path: "/d5data",
				element: <Greeting />,
			},
			{
				path: "/d5data/c/:id",
				element: <ChatPage />,
			},
		],
	},

	{
		path: "/docs",
		element: <DOCS />,
	},

	{
		path: "*", // 404 路由配置都写在最后，起到一个兜底的作用
		element: <NotFond />,
	},
]);
export default router;
